import { useState } from 'react';
import { DateTime } from 'luxon';
import { getAnsweredComponent } from './AnsweredInteractivePreview';

// Compact status for any answerable interactive element that ISN'T
// embed_conversation (multiple_choice/true_false/fill_blank/ordering/
// matching/embed_grid) - these only ever have a current-state row
// (ExerciseStudentSavedInteractiveElement), never a step-by-step history
// like conversations do. When `block` is passed and AnsweredInteractivePreview.jsx
// has a per-type renderer for it (AnsweredFillBlank etc. - most answerable
// types do by now), that renders inline ABOVE the completed/score/date line
// so the actual answer (colored correct/wrong, not a JSON blob) is what you
// see first. Falls back to the completed/score/date + raw-JSON toggle alone
// for whatever type has no dedicated renderer yet, or when no `block` was
// passed at all (some older call sites only ever had `savedState`).
export default function ExerciseAnswerState({ block, savedState }) {
   const [showRaw, setShowRaw] = useState(false);

   if (!savedState) {
      return <p className='workspace-activity-empty-hint'>Студент ще не відповідав.</p>;
   }

   const AnsweredComponent = block ? getAnsweredComponent(block.type) : null;

   return (
      <div className='workspace-exercise-answer-state'>
         {AnsweredComponent ? (
            <div className='workspace-answered-inline'>
               <AnsweredComponent block={block} resultJson={savedState.resultJson} />
            </div>
         ) : ''}
         <span className={'workspace-conversation-status' + (savedState.completed ? ' completed' : ' in-progress')}>
            {savedState.completed ? 'Завершено' : 'В процесі'}
         </span>
         {savedState.score != null ? <span className='workspace-conversation-score'>Результат: {savedState.score}</span> : ''}
         {savedState.dMod || savedState.dAdd ? (
            <span className='workspace-conversation-step-date'>
               {DateTime.fromISO(savedState.dMod || savedState.dAdd).toFormat('dd.MM.yyyy HH:mm')}
            </span>
         ) : ''}
         {!AnsweredComponent && savedState.resultJson ? (
            <span className='workspace-answer-raw-toggle' onClick={() => setShowRaw(v => !v)}>
               {showRaw ? 'Сховати деталі' : 'Показати деталі'}
            </span>
         ) : ''}
         {!AnsweredComponent && showRaw ? <pre className='workspace-answer-raw-json'>{formatJson(savedState.resultJson)}</pre> : ''}
      </div>
   );
}

function formatJson(raw) {
   try {
      return JSON.stringify(JSON.parse(raw), null, 2);
   } catch (e) {
      return raw;
   }
}
